﻿
import $ = require('jquery');

export class ContactForm {
    Name: string;
    Email: string;
    TextMessage: string;

    constructor(name: any, email: any, message: any) {
        this.Name = name;
        this.Email = email;
        this.TextMessage = message;
    }

    send() {
		$("#contactFormSubmit").prop("disabled", true);
		if ($("#name-email-url").val() == null) {
			$.ajax({
				type: 'POST',
				url: "/umbraco/api/ContactForm/SendContactForm/",
				data: JSON.stringify(this),
				contentType: 'application/json; charset=utf-8',
				dataType: 'json'
			}).done(function (data:any) {
				$("#contactFormSubmit").prop("disabled", false);
				if (data == true) {
					$("#contactForm").remove();
					$(".valid").addClass("show");
					$(".invalid").removeClass("show");
				}
				else {
					$(".invalid").addClass("show");
					$(".valid").removeClass("show");
				}
			}).fail(function () {
				$(".invalid").addClass("show");
			});
		}
    }
}

export function initContactForm(){
	$("#contactFormSubmit").click(function () {
		event.preventDefault();
		var contactForm = new ContactForm($("#contactFormName").val(), $("#contactFormEmail").val(), $("#contactFormMessage").val()).send();
	});
}